import { createContext, useContext, useEffect, useState } from "react";
import api, { setUnauthorizedHandler } from "@/lib/api";
import { toast } from "sonner";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = authed

  useEffect(() => {
    let lastToast = 0;
    setUnauthorizedHandler(() => {
      setUser((u) => {
        if (u && Date.now() - lastToast > 3000) {
          lastToast = Date.now();
          toast.error("Sessione scaduta, effettua di nuovo l'accesso");
        }
        return false;
      });
    });
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
